import axios from 'axios';
import store from '@/store'
import router from '@/router';
import { Message } from 'element-ui';

// 创建一个 axios 实例
const apiInstance = axios.create({
	// baseURL: 'http://82.156.202.229:80/prod/admin-api', 
	baseURL: 'https://www.guoketongqi.com/prod/admin-api',
	timeout: 10000, // 请求超时时间
	headers: {
		'Content-Type': 'application/json',
		'tenant-id': '1'
	},
});

const SUCCESS_CODES = [0, 200];
const AUTH_LOGIN_PATH = '/system/auth/login';
const AUTH_REFRESH_PATH = '/system/auth/refresh-token';
const TENANT_ID = '1';
let refreshingTokenPromise = null;
let handlingAuthExpired = false;

const isSuccessCode = (code) => SUCCESS_CODES.includes(code);
const isLoginRequest = (url = '') => url.includes(AUTH_LOGIN_PATH);
const isRefreshRequest = (url = '') => url.includes(AUTH_REFRESH_PATH);

const handleAuthExpired = (msg) => {
	store.dispatch('auth/logout');

	if (handlingAuthExpired) {
		return;
	}

	handlingAuthExpired = true;
	Message.error(msg || '登录状态已过期，请重新登录');

	const currentRoute = router.currentRoute || {};
	const redirectPath = currentRoute.path && currentRoute.path !== '/login' ? currentRoute.fullPath : '';
	const resetHandlingFlag = () => {
		handlingAuthExpired = false;
	};

	router.replace({
		path: '/login',
		query: redirectPath ? { redirect: redirectPath } : {}
	}).then(() => {
		resetHandlingFlag();
	}, () => {
		// 忽略重复跳转报错
		resetHandlingFlag();
	});
};

const requestNewAccessToken = (refreshToken) => {
	const requestUrl = `${apiInstance.defaults.baseURL}${AUTH_REFRESH_PATH}?refreshToken=${encodeURIComponent(refreshToken)}`;

	return axios.post(requestUrl, null, {
		timeout: apiInstance.defaults.timeout,
		headers: {
			'Content-Type': 'application/json',
			'tenant-id': TENANT_ID
		}
	});
};

// 请求拦截器
apiInstance.interceptors.request.use(
	config => {
		// 获取 Vuex 中的 token，判断用户是否登录
		if (store.state.auth.user && store.state.auth.user.accessToken) {
			const token = store.state.auth.user.accessToken; // 假设 token 存储在 auth 模块中
			config.headers['Authorization'] = `Bearer ${token}`;
		}
		if (!config.headers['Content-Type'] && !(config.data instanceof FormData)) {
			config.headers['Content-Type'] = 'application/json';
		}

		// 返回 config 继续请求
		return config;
	},
	error => {
		// 请求错误时，直接返回错误
		return Promise.reject(error);
	}
);


apiInstance.interceptors.response.use(
	response => {
		// 判断响应体的 code 字段
		if (response.data.code === 401) {
			// 如果返回的 code 是 401，表示需要重新获取 token
			const originalRequest = response.config || {};
			const requestUrl = originalRequest.url || '';
			const authUser = store.state.auth.user || {};
			const refreshToken = authUser.refreshToken;

			// 登录接口不进行刷新逻辑，直接抛出业务错误给调用方
			if (isLoginRequest(requestUrl)) {
				return Promise.reject(new Error(response.data.msg || 'unauthorized'));
			}

			// 刷新接口返回 401，说明 refreshToken 已失效，直接退出登录
			if (isRefreshRequest(requestUrl)) {
				handleAuthExpired(response.data.msg || '刷新令牌已过期，请重新登录');
				return Promise.reject(new Error(response.data.msg || 'refresh token expired'));
			}

			if (originalRequest._retry) {
				handleAuthExpired(response.data.msg || '登录状态已过期，请重新登录');
				return Promise.reject(new Error(response.data.msg || 'token expired'));
			}

			if (!refreshToken) {
				handleAuthExpired('登录状态已失效，请重新登录');
				return Promise.reject(new Error('missing refresh token'));
			}

			originalRequest._retry = true;

			if (!refreshingTokenPromise) {
				refreshingTokenPromise = requestNewAccessToken(refreshToken)
					.then(refreshResponse => {
						const refreshResult = refreshResponse.data || {};

						if (isSuccessCode(refreshResult.code) && refreshResult.data && refreshResult.data.accessToken) {
							// 更新 Vuex 中的 token
							store.commit('auth/SET_AUTH', refreshResult.data);
							return refreshResult.data.accessToken;
						}

						throw new Error(refreshResult.msg || '刷新令牌已过期');
					})
					.catch(err => {
						console.error('Token refresh failed:', err);
						handleAuthExpired(err.message || '刷新令牌已过期，请重新登录');
						throw err;
					}).then(result => {
						refreshingTokenPromise = null;
						return result;
					}, err => {
						refreshingTokenPromise = null;
						throw err;
					});
			}

			return refreshingTokenPromise.then(newToken => {
				// 重试原始请求
				originalRequest.headers = originalRequest.headers || {};
				originalRequest.headers['Authorization'] = `Bearer ${newToken}`;
				return apiInstance(originalRequest); // 重新发起原请求
			});
		}
		// 如果正常的响应，直接返回
		return response;
	},
	error => {
		// 其他错误处理
		if (!error.response) {
			console.error('Network error or CORS issue:', error);
			return Promise.reject(error);
		}

		// 针对其他错误（如请求超时等）
		console.error('Request failed:', error.response);
		return Promise.reject(error);
	}
);





// 封装 GET 请求
export const apiGet = (url, params) => {
	return apiInstance
		.get(url, {
			params
		})
		.then(response => response.data)
		.catch(error => {
			console.error('API GET Error:', error);
			throw error;
		});
};

// 封装 GET 请求（兼容后端使用 GET + JSON Body 的场景）
export const apiGetWithData = (url, data) => {
	const payload = data || {};
	return apiInstance
		.request({
			url,
			method: 'get',
			data: JSON.stringify(payload)
		})
		.then(response => response.data)
		.catch(error => {
			console.error('API GET With Data Error:', error);
			throw error;
		});
};

// 封装 POST 请求
export const apiPost = (url, data) => {
	return apiInstance
		.post(url, JSON.stringify(data))
		.then(response => response.data)
		.catch(error => {
			console.error('API POST Error:', error);
			throw error;
		});
};

// 封装 POST 请求（Blob）
export const apiPostBlob = (url, data) => {
	return apiInstance
		.post(url, JSON.stringify(data), {
			responseType: 'blob'
		})
		.then(response => response)
		.catch(error => {
			console.error('API POST Blob Error:', error);
			throw error;
		});
};

// 封装 PUT 请求
export const apiPut = (url, data) => {
	return apiInstance
		.put(url, data)
		.then(response => response.data)
		.catch(error => {
			console.error('API PUT Error:', error);
			throw error;
		});
};

// 封装 DELETE 请求
export const apiDelete = (url, params) => {
	return apiInstance
		.delete(url, {
			params
		})
		.then(response => response.data)
		.catch(error => {
			console.error('API DELETE Error:', error);
			throw error;
		});
};
//文件上传
export function uploadFile(formData) {
	return apiInstance({
			url: '/infra/file/upload', // 根据你的实际上传接口地址修改
			method: 'post',
			data: formData,
			headers: {
				'Content-Type': 'multipart/form-data'
			}
		}).then(response => response.data)
		.catch(error => {
			console.error('File upload error:', error);
			throw error;
		});
}
